import {CheckOpenHoursCustomerCareService} from './CheckOpenHoursCustomerCareService.js'
export default class CustomerCareServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {CheckOpenHoursCustomerCareService}
   */
  static checkOpenHoursCustomerCareService = ({config}) => new CheckOpenHoursCustomerCareService({config})
}
